export default __webpack_public_path__ + "static/media/compiegne7.9e1e70dc.jpg";